export default {_name:'group.tabs',module:'Field',view:'Element/Group/Tabs',options:{key:'tabs',xs:12,ms:12}}